export const fontSizes = {
  xxl: '4rem',
  xl: '2rem',
  l: '1.5rem',
  m: '1.2rem',
  r: '1rem',
  s: '0.8rem',
};